import { api } from "../../app/api.js";
import { display_errors } from "../../helpers/forms.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Reset Password</h1>
                
                <form id="reset-form" class="form">
                    <div class="input">
                        <label for="Password">Password</label>
                        <input type="password" id="Password" name="password" required/>
                        <p class="hint">Password must be at least 12 characters long.</p>
                    </div>
                    
                    <div class="input">
                        <label for="PasswordConfirm">Confirm Password</label>
                        <input type="password" id="PasswordConfirm" name="password_confirm" required/>
                        <p class="error hidden">Passwords must match.</p>
                    </div>
        
                    <button id="ResetSubmit" type="submit">Submit</button>
                    <div id="ResetErrors" class="errors hidden"></div>
                </form>
        
                <div id="reset-complete" class="form hidden">
                    <p>Your password has been reset.</p>
        
                    <a id="LoginLink" href="/login" class="btn btn-primary">Go to Login</a>
                </div>
            </div>
        </div>
    `,

    $form: null,
    $errors: null,
    $submit: null,


    submit(e) {
        e.preventDefault();

        this.$errors.classList.add('hidden');
        this.$errors.textContent = '';

        let errors = {};

        const password = this.$form.password.value;
        const passwordConfirm = this.$form.password_confirm.value;
        if (password !== passwordConfirm) {
            errors['password_confirm'] = 'Passwords do not match';
        }

        if (Object.keys(errors).length > 0) {
            display_errors(this.$errors, {errors: errors}, this.$form);
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);

        api.post({
            url: '/auth/reset-password',
            data: {
                token: urlParams.get('t'),
                password: password,
            },
            success: (response) => {
                this.$form.classList.add('hidden');
                const $complete = document.getElementById('reset-complete');
                $complete.classList.remove('hidden');
            },
            error: (response) => {
                display_errors(this.$errors, response, this.$form);
            }
        })
    },

    check_password(){
        if (this.$form.password.value.length < 12) {
            this.$form.password.classList.add('error');
        } else {
            this.$form.password.classList.remove('error');
        }

        if (this.$form.password.value !== this.$form.password_confirm.value && this.$form.password_confirm.value !== '') {
            this.$form.password_confirm.classList.add('error');
        } else {
            this.$form.password_confirm.classList.remove('error');
        }
    },

    _boundSubmit: null,
    _boundCheckEmail: null,
    _boundCheckPassword: null,

    onMount() {
        this.$form = document.getElementById('reset-form');
        this.$errors = document.getElementById('ResetErrors');

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);

        this._boundCheckPassword = this.check_password.bind(this);
        this.$form.password.addEventListener('input', this._boundCheckPassword);
        this.$form.password_confirm.addEventListener('input', this._boundCheckPassword);
    },

    onUnmount() {
        if (this.$form && this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
        if (this.$form && this._boundCheckPassword) {
            this.$form.password.removeEventListener('input', this._boundCheckPassword);
            this.$form.password_confirm.removeEventListener('input', this._boundCheckPassword);
        }
    },
}
